import userService from "../../../services/user.service";

async function getTeams() {
  try {
    const response = await userService.getTeams(-1, 0, "");
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to fetch teams."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching teams:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function addTeamToDatabase({ teamName, teamDescription, isActive }) {
  try {
    const payload = {
      name: teamName,
      description: teamDescription,
      active: isActive,
    };
    const response = await userService.addTeam(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to add team."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error adding team:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function updateTeamInDatabase({ teamId, teamName, teamDescription, isActive }) {
  try {
    const payload = {
      id: teamId,
      name: teamName,
      description: teamDescription,
      active: isActive,
    };
    const response = await userService.updateTeam(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to update team."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error updating team:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  addTeamToDatabase,
  getTeams,
  updateTeamInDatabase,
  teamTools: [
    {
      type: "function",
      function: {
        name: "getTeams",
        description: "Fetch all teams from the database. You must return all teams without skipping any data.",
        parameters: {
          type: "object",
          properties: {},
        },
      },
    },
    {
      type: "function",
      function: {
        name: "updateTeamInDatabase",
        description: "Update an existing team in the database",
        parameters: {
          type: "object",
          properties: {
            teamId: {
              type: "string",
              description: "The unique ID of the team to be updated",
            },
            teamName: {
              type: "string",
              description: "Name of the team",
            },
            teamDescription: {
              type: "string",
              description: "Description of the team",
            },
            isActive: {
              type: "boolean",
              description: "Whether the team is active or not",
            },
          },
          required: ["teamId", "teamName", "teamDescription"],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "addTeamToDatabase",
        description: "Add a team to the database",
        parameters: {
          type: "object",
          properties: {
            teamName: {
              type: "string",
              description: "Name of the team",
            },
            teamDescription: {
              type: "string",
              description: "Description of the team",
            },
            isActive: {
              type: "boolean",
              description: "Whether the team is active or not",
            },
          },
          required: ["teamName", "teamDescription"],
        },
      },
    },
  ],
};
